module.exports = "\n<div>\n    <div id=\"top\" style = \"position:absolute; top:-10px\"></div>\n    <router-outlet></router-outlet>\n</div>\n"